export function createUuid() {
  const cryptoRef = typeof window !== "undefined" ? window.crypto || window.msCrypto : undefined;

  if (cryptoRef && typeof cryptoRef.randomUUID === "function") {
    return cryptoRef.randomUUID();
  }

  if (cryptoRef && typeof cryptoRef.getRandomValues === "function") {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (char) =>
      (Number(char) ^ (cryptoRef.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(char) / 4)))).toString(16)
    );
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Date.now() + Math.random() * 16) % 16 | 0;
    return (char === "x" ? random : (random & 0x3) | 0x8).toString(16);
  });
}
